<template lang="pug">
include /@ibkr/lib.common/src/icon/color
ib-col(class="flex")
    ib-row
        ib-col
            div(v-if="showWarning === true && selectedDomain === 'uk'", class="product-warning")
                ib-infobox(appearance="sm", tone="warning") {{ $t('crypto_disclosure') }}
        ib-col(v-if="status === 'selected'")
            Services(ref='services')
        ib-col()
            div()
                ib-col(v-show="selectedTab === 'products' && status === 'selected'")
                    ProductType(ref='productType')
                ib-col(v-show="(selectedTab === 'products' && status === 'selected') || (selectedTab === 'exchanges' && status === 'selected')")
                    SelectRegions
                ib-col(v-show="selectedTab === 'products' && status === 'selected'")
                    NewProduct(ref="newprod")
                ib-col(v-show="(selectedTab === 'products' && status === 'selected') || (selectedTab === 'exchanges' && status === 'selected') || (selectedTab === 'contracts' && status === 'selected')")
                    Search(ref='searchExchange')
        div(
            class="text-left product-exchange",
            v-if="status === 'selected' && (selectedTab === 'products' || selectedTab === 'exchanges')"
        )
            span(v-if="$media.xl || $media.l || $media.m || $media.s")
                ib-button(
                    tone="remove",
                    @click="getResults",
                    class="inversed-black",
                    :disabled="!canSubmit",
                    :busy="loadingResult",
                ) {{ $t('view_results') }}
                ib-button(
                    @click="resetFilters",
                    class="fg-negative text-center inversed",
                    tone="border-remove",
                ) {{ $t('reset_filter') }}
            span(v-else)
                ib-button(
                    class="text-center",
                    tone="remove",
                    :disabled="!canSubmit",
                    :busy="loadingResult",
                    width="100%"
                ) {{ $t('view_results') }}
                ib-button(
                    @click="resetFilters",
                    class="fg-negative text-center inversed",
                    tone="border-remove",
                    width="100%"
                ) {{ $t('reset_filter') }}
    ib-row(v-if="status === 'filterResults' || status === 'exchangeResults'")
        ib-col(class="insety-8 results-options")
            div(class="results-info")
                p {{ $t('search_results') }}: 
                    span(v-if="status === 'filterResults'", class="filtered-products") {{ total.toLocaleString() }} 
                    span(v-if="status === 'filterResults'", class="filter-text") {{ $t('products_found') }}
                    span(v-else-if="status === 'exchangeResults'", class="filtered-products") {{ total }}
                    span(v-if="status === 'exchangeResults'", class="filter-text")  {{ $t('exchanges_found') }}
                div(class="filters")
                    p(v-if="status === 'filterResults'") {{ $t('product_type') }}: 
                        span(class="filtered-product-types") {{ pdtTypes }} 
                        span() {{ $t('region') }}: 
                        span(class="filter-text") {{ selectedRegion }} 
                        span() {{ $t('filter') }}: 
                        span(class="filter-text") {{ newProducts }}
            div
                ib-button(class="dark-grey-text start", @click="downloadMapping", id="download") {{ $t('download_to_xls') }}
                ib-button(@click="startOver", class="dark-grey-text start") {{ $t('start_over') }}
        ib-col(class="productTypes", v-if="status === 'filterResults' || status === 'exchangeResults'")
            ib-button(
                class="selectAllType"
                :class="{ isActive: selectedProductType === 'all' }"
                @click="select('all')"
            )
                span(class="typeValue") {{ $t('show_all') }}
                br
                span(
                    class="total"
                ) {{ total.toLocaleString() }}
            ib-button(
                v-for="(product, index) in types",
                :key="index",
                class="types"
                :class="{ isActive: selectedProductType === product.symbol }"
                @click="select(product.symbol)"
            )
                span(class="typeValue") {{ $t(product.name) }}
                br
                span(
                    class="total"
                ) {{ product.totalCount.toLocaleString() }}
    ExchangeResults(v-if="status === 'exchangeResults'")
    ProductResults(ref="productResults", v-if="status === 'prodResults'")
    ProductSearchResults(v-if="status === 'filterResults'")
    ib-row(v-if="status === 'loading'")
        ib-progress-circular(width="128px", height="128px", class="alignment")
    //States
</template>
<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import api from '../api/index.js'

    import Services from './Services.vue';
    import CountryOfResidence from './CountryOfResidence.vue';
    import Search from './Search.vue';
    import NewProduct from './NewProduct.vue';
    import ProductType from './ProductType.vue';
    import SelectRegions from './SelectRegions.vue';
    import ExchangeResults from './ExchangeResults.vue';
    import ProductResults from './ProductResults.vue';
    import ProductSearchResults from './ProductSearchResults.vue';
    import States from './States.vue';
    import { exportCSV } from '../utils/fileUtils.js'

    export default {
        name: 'ProductsExchanges',
        components: {
            Services,
            CountryOfResidence,
            Search,
            NewProduct,
            ProductType,
            SelectRegions,
            ExchangeResults,
            ProductResults,
            ProductSearchResults,
            States,
        },
        data() {
            return {
                loadingResult: false,
                data: ["One","Two","Three","Four","Five","Six","Seven","Eight"],
                value: null,
                isActive: false,
                loginURL: '',
                total: 0,
            }
        },
        mounted() {
            // On page load getRestrictedProducts API will fetch products with i158 restrictions
            console.debug("Domain is: ", this.selectedDomain);
            if(this.selectedDomain === 'jp'){
                api.getRestrictedProducts()
                    .then((response) => {
                        this.seti158Restrictions(response);
                    })
                    .catch((error) => console.log("Failed to fetch i158 restrictions"));
            }
            
            setTimeout(() => {
                this.reset();
                if(this.$route.params.type){
                    this.setTab("products");
                    this.reset();
                    let index = this.productTypes.findIndex(type => type.symbol === this.$route.params.type.toUpperCase());
                    if(index === -1){
                        $alert("Please enter valid product type in the URL");
                    } else {
                        this.$refs.productType.select(index);
                    }
                }
            }, 100);

            api.fetchAllExchanges()
                .then((response) => {
                    const exchanges = [];
                    this.filterProductTypes(response.exchanges);
                    this.setExchanges(this.filteredResults);
                })
                .catch((error) => console.log(error))
            
            // API to get URL for user login page
            api.getLoginURL()
                .then(response => {
                    this.loginURL = response.domain;
                    console.debug("Login URl: ", this.loginURL);
                })
            
            window.addEventListener('message', (event) => {
                if((event.data === 'login' || event.data === 'signUp') && event.origin === "https://www.interactivebrokers.com"){
                    if(event.data  === 'login'){
                        if(window.location.href.search(/test.php/) != -1){
                            console.debug("Test page redirected to CP Alpha");
                            window.open(this.loginURL + "/sso/Login?forwardTo=81","_blank");
                        } else {
                            window.open(this.loginURL + "/sso/Login","_blank");
                        }
                    } else if(event.data === 'signUp') {
                        window.open(this.selectedTrackingUrl,"_blank");
                    }
                }
            }, false);

            window.addEventListener('keyup', (event) => {
                if (event.key === "Enter" && this.selectedTab != 'contracts' && this.preventSearch === false) {
                    if (this.selectedTab === 'products' && this.selectedProductTypes.length === 0 && this.selectedProduct === '') {
                        return;
                    }
                    if(this.status === 'prodResults'){
                        this.$refs.productResults.submit();
                    } else {
                        this.getResults();
                    }
                }
            });
        },
        watch: {
            '$route.params.type'(to, from) {
                console.debug("Change in type param", this.selectedTab);
                if(to){
                    this.setTab("products");
                    this.reset();
                    let currentIndex = this.productTypes.findIndex(type => type.symbol === to.toUpperCase());
                    if(currentIndex === -1){
                        $alert("Please enter valid product type in the URL");
                    } else {
                        this.$refs.productType.select(currentIndex);
                    }
                } else {
                    this.reset();
                }
            },
        },
        methods: {
            resetFilters() {
                console.debug('Reset Filters...');
                this.$refs.searchExchange.clearField(true);
                this.reset();
                this.$refs.newprod.reset();
            },
            getResults() {
                window.scrollTo(0, 0);
                let sortOptions;
                if(this.selectedTab === 'products'){
                    sortOptions = { type: 'symbol', dir: 'asc' };
                } else if(this.selectedTab === 'exchanges'){
                    sortOptions = { type: 'id', dir: 'asc' };
                }
                this.setCurrentSort(sortOptions);
                if(this.status === "exchangeResults"){
                    this.filterExchangeResultsByProductType();
                } else {
                    this.setStatus('loading');
                    this.search();
                }
            },
            startOver() {
                this.total = 0;
                this.reset();
                this.toggleProductDisclosures();
            },
            toggleProductDisclosures(){
                const notes = document.querySelector('.notes');
                const mfundDisclosure = document.querySelector('.mutual-fund-disclosure');
                const etfDisclosure = document.querySelector('.etf-disclosure');
                const cryptocurrencyUsDisclosure = document.querySelector('.cryptocurrency-disclosure');
                const exchangeSpecificDisclosure = document.querySelector('.exchange-specific-disclosure');
                const usDisclosure = document.querySelector('.us-disclosure');
                const nonUsDisclosure = document.querySelector('.non-us-disclosure');
                const usDisclosureNotes = document.querySelectorAll('.us-disclosure-notes');
                const nonUsDisclosureNotes = document.querySelectorAll('.non-us-disclosure-notes');
                const disclosureText = document.querySelector('.disclosure-text');
                
                for(let i = 0; i < usDisclosureNotes.length; i++){
                    usDisclosureNotes[i].style.display = "none";
                }
                for(let i = 0; i < nonUsDisclosureNotes.length; i++){
                    nonUsDisclosureNotes[i].style.display = "none";
                }
                if(notes){
                    notes.style.display = "none";
                }
                if(etfDisclosure){
                    etfDisclosure.style.display = "none";
                }
                if(cryptocurrencyUsDisclosure){
                    cryptocurrencyUsDisclosure.style.display = "none";
                }
                mfundDisclosure.style.display = "none";
                exchangeSpecificDisclosure.style.display = "none";
                usDisclosure.style.display = "none";
                nonUsDisclosure.style.display = "none";
                disclosureText.style.display = "none";
                
                const cfdDisclosure = document.querySelector('#retail-investors');
                cfdDisclosure.style.display = "none";
            },
            downloadMapping() {
                if(this.status === 'exchangeResults'){
                    this.setSecDefData("");
                    const header = ['DESCRIPTION', 'PRODUCT', 'COUNTRY']
                    const fields = ['id', 'assets', 'country']
                    exportCSV(header, fields, this.listedResults, this.secDefData, ',', 'Search Results');
                }   else if(this.status === 'filterResults'){
                    const header = ['SYMBOL', 'DESCRIPTION', 'IBKR-SYMBOL', 'CURRENCY', 'PRODUCT', 'REGION', 'EXCHANGE']
                    const fields = ['symbol', 'description', 'localSymbol', 'currency', 'type', 'country', 'exchangeId']
                    exportCSV(header, fields, this.searchResults, this.secDefData, ',', 'Search Results');
                }
            },
            select(type) {
                this.total = 0;
                let sortOptions = { type: 'symbol', dir: 'asc' };
                this.setCurrentSort(sortOptions);
                this.setSearchProductType([]);
                if(type === 'all'){
                    if(this.status != 'exchangeResults'){
                        this.typesList.forEach(type => {
                            this.setSearchProductType(type.symbol);
                        })
                    }
                    this.setSelectedProductType("all");
                } else {
                    if(this.status != 'exchangeResults'){
                        this.setSearchProductType(type);
                    }
                    this.setSelectedProductType(type);
                }
                this.setPageNumber(1);
                this.getResults();
                this.toggleProductDisclosures();
            },
            filterExchangeResultsByProductType() {
                if(this.selectedProductType === 'all'){
                    this.setListedResults(this.filteredExchangeResults);
                } else {
                    let pdt = this.productTypes.find(product => product.symbol === this.selectedProductType);
                    const filteredResults = this.filteredExchangeResults.filter(exchange => exchange.assets.includes(pdt.description));
                    this.setListedResults(filteredResults);
                }
            },
            ...mapActions(['reset', 'setStatus', 'search', 'setExchanges', 'setSelectedProductType', 'filterProductTypes', 
            'setSecDefData', 'setSearchProductType', 'setPageNumber', 'setCurrentSort', 'setListedResults', 'setSelectedRegion', 'setNewProducts', 'seti158Restrictions', 'setTab'])
        },
        computed: {
            canSubmit: function() {
                if(this.selectedRegions.length != 0 || this.userSelection === true || this.selectedProductTypes.length > 0 || this.selectedProduct.length > 0){
                    return true;
                } else {
                    return false;
                } 
            },
            types: function() {
                if(this.status === "exchangeResults"){
                    this.total += this.filteredExchangeResults.length;
                } else {
                    this.total = this.typesList.reduce((accumulator, type) => {
                        return accumulator += type.totalCount;
                    }, 0)
                }
                return this.typesList;
            },
            pdtTypes: function() {
                let pdt = [];
                const prodTypes = this.typesList.map(type => type.symbol);
                console.debug("prodtypes", prodTypes);
                prodTypes.forEach(type => {
                    const tp = this.productTypes.find(product => product.symbol === type);
                    pdt.push(tp.description);
                });
                return pdt.join(", ");
            },
            selectedRegion: {
                get: function(){
                    if(this.$store.state.selectedRegion.length === 0){
                        return "All";
                    } else {
                        return this.$store.state.selectedRegion.join();
                    }
                },
                set: function(newValue){
                    this.setSelectedRegion(newValue);
                }
            },
            newProducts: {
                get: function(){
                    if(this.$store.state.newProducts === 'all'){
                        return "All";
                    } else if(this.$store.state.newProducts === 'exiting'){
                        return "Old (> 30 days)";
                    } else if(this.$store.state.newProducts === 'new'){
                        return "New (< 30 days)";
                    }
                },
                set: function(newValue){
                    this.setNewProducts(newValue);
                }
            },
            ...mapGetters(['selectedProductTypes','selectedRegions', 'selectedDomain', 'selectedTrackingUrl']),
            ...mapState(['selectedTab','status','selectedCountry','selectedProduct','listedResults',
                     'selectedExchange', 'searchResults','typesList', 'selectedProductType',
                     'restrictedProductTypes', 'filteredResults', 'userSelection', 'preventSearch', 'secDefData', 'productTypes', 
                     'filteredExchangeResults', 'searchProductType', 'showWarning'])
        }
    }
</script>
<style lang="less">
.info {
    &:hover {
        .tooltext {
            visibility: visible;
        }
    }
    svg {
        fill:#D91222;
        width: 0.9em;
        height: 0.9em;
        cursor: pointer;
        vertical-align: baseline;
    }
    .tooltext {
        visibility: hidden;
        width: 200px;
        background-color: black;
        color: #fff;
        text-align: center;
        padding: 5px 0;
        border-radius: 6px;
        position: absolute;
        z-index: 1;
    }
}
@media (max-width: 991px) {
    .product-exchange {
        display:flex;
        flex-direction: column;
        width: 100%
    }
    .inversed, .inversed-black {
        width: 100%
    }
}
.product-exchange {
    padding-top: 16px;
    button {
        border-radius: 0;
        font-size: 0.8125rem;
        background-color: #fcfcfc;
        svg {
            width: 1em;
            height: 1em;
            vertical-align: sub;
        }
        &:hover {
            background-color: white;
        }
        &::after {
            background-color: white;
            opacity: 0;
        }  
    }
}
.inversed-black {
    &.accent {
        font-size: 16px;
    }
    &:hover {
        background-color: #db1222 !important;
    }
}
.alignment {
    position: relative;
    left: 50%;
}
@media (min-width:768px) {
    .start {
        float: right;
    }
}
@media (max-width:768px) {
    .start {
        width: 100%;
    }
}
#download {
    background-color: #D91222;
    color: #FFFFFF;
}
.productTypes{
    display: flex;
    margin: 0;
    padding-bottom: 8px;
    overflow-x: scroll;
}
.selectAllType {
    border-radius: 0;
    // width: calc(100 - 10px);
    margin-left: 0;
    margin-right: 20px;
    margin-top: 5px;
    flex-basis: 150px;
    flex-grow: 0;
    flex-shrink: 0;
}
.isActive {
    background-color: #D91222;
    color: #FFFFFF;
    margin-left: 0px;
}
.typeValue {
    font-weight: 900;
    font-size: 16px;
}
.total {
    font-size: 13px;
}
.types{
    margin-left: 0px;;
    margin-right: 20px;
    margin-top: 5px;
    flex-basis: 150px;
    flex-grow: 0;
    flex-shrink: 0;
}
@media (min-width:768px) {
    .results-info {
        max-width: 800px;
    }
    .results-options {
        display: flex;
        justify-content: space-between;
    }
    .filter-text {
        color: #D91222;
    }
    .filters {
        font-size: 12px;;
    }
    .filtered-products {
        font-weight: bold;
        color: #D91222;
    }
    .filtered-product-types {
        font-style: italic;
        color: #D91222;
    }
}
@media (max-width:768px) {
    .results-info {
        width: 100%;
    }
    .filter-text {
        color: #D91222;
    }
    .filters {
        font-size: 12px;;
    }
    .filtered-products {
        font-weight: bold;
        color: #D91222;
    }
    .filtered-product-types {
        font-style: italic;
        color: #D91222;
    }
}
.product-warning {
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>
